<div class="htoolbar">
  <div class="firstrow">
    <div class="headertext">
      <a (click)="redirectPage('dashboard')" class="cursor-pointer"
      >Dashboard</a
    >
    /
    <b>Monitor</b>
      <!-- /
      <b>Monitor</b> -->
    </div>
    <div class="toolbar">
      <!-- <div class="filter pL10">
                <app-datetimerangepicker [dates]="selectedDateRanges"
                    (dateChangeEvent)="filterChange($event, 'date')"></app-datetimerangepicker>
            </div> -->
            <i class="fa fa-calendar-o" aria-hidden="true" style="color: #9b9999;"></i>
      <app-daterangepicker
        [InitialDates]="InitialDates"
        (selectedDates)="filterChange($event, 'date')"
      ></app-daterangepicker>
    </div>
  </div>
</div>

<div class="d-fc p-20">
  <div class="row pT-10">
    <div class="col-md-3 pR-0">
      <div class="card filterDiv">
        <div class="cardTitle">Filters</div>
        <div class="card-body">
          <!-- <div class="filter" *ngIf="filter.asset.data.length > 0">
            <label>Select Zone</label>
            <app-dropdown
            [values]="zoneList"
            [selected]="selectedZone"
            [displayMember]="'name'"
            (newSelectionEvent)="changezone($event)"
            type="object"
          >
          </app-dropdown>
        </div> -->
          <div class="filter" *ngIf="filter.asset.data.length > 0">
            <label>Select Asset (Max 3 Assets)</label>
          <app-searchable-dropdown
              [values]="filter.asset.data"
              [selected]="filter.asset.selected"
              [displayMember]="'asset'"
              [isMultiple]="true"
              (newSelectionEvent)="changeFilter($event, 'asset')"
              type="object"
              [maxTags]="3"
            >
          </app-searchable-dropdown>
          </div>
          <div class="filter" *ngIf="filter.raw.data.length > 0">
            <label>Select Tags (Max 10 tags)</label>
            <!-- <app-dropdown [values]="filter.raw.data" [selected]="filter.raw.selected"
                             (newSelectionEvent)="changeFilter($event,'raw')" [displayMember]="'tag'" type="object">
                        </app-dropdown> -->
            <app-searchable-dropdown
              *ngIf="showTags"
              [values]="filter.raw.data"
              [displayMember]="'component'"
              [selectCaption] = ""
              [selected]="filter.raw.selected"
              [maxTags]="10"
              (newSelectionEvent)="changeFilter($event, 'raw')"
              [isMultiple]="true"
            ></app-searchable-dropdown>
          </div>
          <div class="filter">
            <label>Select Aggregation Time</label>
            <app-dropdown
              [values]="filter.aggregation.data"
              [selected]="filter.aggregation.selected"
              (newSelectionEvent)="changeFilter($event, 'aggregation')"
              [displayMember]="'time'"
              type="object"
            >
            </app-dropdown>
          </div>
          <div class="border"></div>
          <div class="pT-10 pL-10">
            <div class="row">
              <div class="col-6">
                <button class="btn btn-primary" (click)="clearTags()">
                  Clear
                </button>
              </div>
              <div class="col-6 text-right" style="padding-left: 40px;">
                <button class="btn btn-primary" (click)="getData()">
                  Load Graph  
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="card">
        <div class="cardTitle">Data</div>
        <div class="card-body">
          <div
          *ngIf="!chartData || this.chartData[0]?.xaxis.length===0"
          style="
            height: calc(100vh - 215px);
            padding: 20px;
            font-size: 18px;
            font-family: 'sfpro-r';
          "
        >
          <app-message  [message]="'No Data Found'"></app-message>
        </div>
          <ng-container *ngIf="chartData && this.chartData[0]?.xaxis.length> 0">
            <app-stockchart [data]="chartData"></app-stockchart>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

